import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
let Navigation = class Navigation extends Vue {
    get mapping() {
        const mapping = {
            'company.profile': {
                label: 'General',
                icon: 'fe-home'
            },
            'company.profile.contacts': {
                label: 'Contacts',
                icon: 'fe-phone'
            },
            'company.profile.socials': {
                label: 'Socials',
                icon: 'fe-twitter'
            },
            'company.profile.billing': {
                label: 'Billing',
                icon: 'fe-dollar-sign'
            },
            'company.profile.onlineRegistration': {
                label: 'Appointment booking',
                icon: 'fe-edit-3',
            },
            'company.profile.schedule': {
                label: 'Schedule',
                icon: 'fe-calendar'
            },
            'company.profile.builder': {
                label: 'Builder',
                icon: 'fe-sliders'
            },
            'company.profile.notifications': {
                label: 'Notifications',
                icon: 'fe-bell'
            },
            'company.profile.printTemplates': {
                label: 'Print templates',
                icon: 'fe-printer'
            },
            'company.profile.integrations': {
                label: 'Integrations',
                icon: 'fe-share-2'
            },
            'company.profile.settings': {
                label: 'Others',
                icon: 'fe-settings'
            },
        };
        if (!this.$loadModule('billing')) {
            delete mapping['company.profile.billing'];
        }
        if (!this.$loadModule('onlineRegistration')) {
            delete mapping['company.profile.onlineRegistration'];
        }
        return mapping;
    }
    get tab() {
        if (!this.$route.name)
            return '';
        return this.mapping[this.$route.name].label;
    }
};
Navigation = __decorate([
    Component({
        components: {},
    })
], Navigation);
export default Navigation;
